import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);
  const isActive = (path) => location.pathname === path;
  return (
    <div>
      <header className={`premium-header ${scrolled ? "header-scrolled" : ""}`}>
        {" "}
        <div className="header-container">
          {" "}
          {/* LOGO */}{" "}
          <Link to="/" className="header-logo">
            <img src="/images/scaleAX.webp" alt="scaleAX" className="logo" />
          </Link>{" "}
          {/* DESKTOP NAVIGATION */}{" "}
          <nav className={`desktop-nav ${menuOpen ? "mobile-open" : ""}`}>
            {" "}
            <Link
              to="/about"
              className={`nav-link ${isActive("/about") ? "active" : ""}`}
            >
              {" "}
              About{" "}
            </Link>{" "}
            <Link
              to="/what-we-do"
              className={`nav-link ${isActive("/what-we-do") ? "active" : ""}`}
            >
              {" "}
              What We Do{" "}
            </Link>{" "}
            <Link
              to="/how-we-work"
              className={`nav-link ${isActive("/how-we-work") ? "active" : ""}`}
            >
              {" "}
              How We Work{" "}
            </Link>{" "}
            <Link
              to="/careers"
              className={`nav-link ${isActive("/careers") ? "active" : ""}`}
            >
              {" "}
              Careers{" "}
            </Link>{" "}
            <div className="nav-dropdown">
              {" "}
              <button className="nav-link dropdown-toggle-btn">
                {" "}
                Resources <span className="dropdown-arrow">⌄</span>{" "}
              </button>{" "}
              <div className="resources-dropdown">
                {" "}
                <Link to="/resources">Resources</Link>{" "}
                <Link to="/insights">Insights</Link>{" "}
                <Link to="/case-studies">Case Studies</Link>{" "}
              </div>{" "}
            </div>{" "}
            {/* MOBILE CTA */}{" "}
            <Link to="/contact" className="mobile-cta">
              {" "}
              Book a Briefing Call{" "}
            </Link>{" "}
          </nav>{" "}
          {/* DESKTOP CTA */}{" "}
          <Link to="/contact" className="header-cta">
            {" "}
            <span>Book a Briefing Call</span>{" "}
            {/* <span className="cta-arrow">↗</span>{" "} */}
          </Link>{" "}
          {/* MOBILE TOGGLE */}{" "}
          <button
            className={`mobile-toggle ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation"
            aria-expanded={menuOpen}
          >
            {" "}
            <span></span> <span></span> <span></span>{" "}
          </button>{" "}
        </div>{" "}
      </header>
    </div>
  );
};

export default Header;
